<template>
  <a
    class="rossetto-button"
    :class="`rossetto-button--${type}`"
    :href="url"
    :target="buttonTarget">
    <component :is="buttonType" />
    <span><slot /></span>
  </a>
</template>

<script>
import PdfButton from './RossettoButton/PdfButton.vue'
import _ from 'lodash'

export default {
  data: () => ({
    typeMap: {
      pdf: PdfButton
    }
  }),
  props: {
    type: {
      type: String,
      default: 'default'
    },
    url: {
      type: String,
      default: '#'
    }
  },
  computed: {
    buttonType: {
      get () {
        return this.typeMap[this.type]
      }
    },
    buttonTarget: {
      get () {
        const keys = _.keys(this.typeMap)
        return _.includes(keys, this.type) ? '_blank' : '_self'
      }
    }
  }
}
</script>

<style lang="scss">

@import '../assets/scss/breakpoint.scss';

/* @group Button */
@mixin rossetto-button($baseColor, $textColor) {
  display: flex;
  align-items: center;
  margin-top: 5rem;
  border-radius: 0;
  font-size: 1.4rem;
  color: $textColor;
  text-decoration: none;
  transition: color .3s ease-out;
  span{
    font-size: 1.6rem;
    display: inline-block;
    position: relative;
    transition: color .3s ease-out;
    &:after{
      display: block;
      content: "";
      position: absolute;
      bottom: -4px;
      width: 100%;
      height: 1px;
      background: $baseColor;
      transform: scaleX(0);
      transform-origin: right;
      transition: transform .3s ease-out;
    }
    &:hover{
      color: $baseColor;
      &:after{
        transform: scaleX(1);
        transform-origin: left;
      }
    }
  }

  @include media(">=xlarge"){
    span{
      font-size: 1.8rem;
    }
  }

  svg{
    margin-right: 2rem;
    path{
      transition: fill .3s ease-out;
      fill: #e30045;
    }
  }

}
.rossetto-button--pdf{
  @include rossetto-button(#0b3277, #0b3277);
}
.accordion .rossetto-button--pdf{
  @include rossetto-button(#0b3277, #0b3277);
  margin-top: 0;
}

/* @end */

</style>
